import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './EssentialLinkButton.css';

interface EssentialLinkButtonProps {
  text: string;
  href: string;
  icon: ReactNode;
  className?: string;
  subtitle?: string;
  internal?: boolean;
}

const EssentialLinkButton: React.FC<EssentialLinkButtonProps> = ({ 
  text, 
  href, 
  icon,
  className = '',
  subtitle,
  internal = false
}) => {
  const isDisabled = !href || href === '';
  
  if (isDisabled) {
    return (
      <div className={`essential-link-button ${className} disabled`}>
        <div className="essential-link-button-icon">
          {icon}
        </div>
        <div className="essential-link-button-text-container">
          <span className="essential-link-button-text">{text}</span>
          {subtitle && <span className="essential-link-button-subtitle">{subtitle}</span>}
        </div>
      </div>
    );
  }
  
  if (internal) {
    return (
      <Link to={href} className={`essential-link-button ${className}`}>
        <div className="essential-link-button-icon">
          {icon}
        </div>
        <div className="essential-link-button-text-container">
          <span className="essential-link-button-text">{text}</span>
          {subtitle && <span className="essential-link-button-subtitle">{subtitle}</span>}
        </div>
      </Link>
    );
  }
  
  return (
    <a href={href} className={`essential-link-button ${className}`} target="_blank" rel="noopener noreferrer">
      <div className="essential-link-button-icon">
        {icon}
      </div>
      <div className="essential-link-button-text-container">
        <span className="essential-link-button-text">{text}</span>
        {subtitle && <span className="essential-link-button-subtitle">{subtitle}</span>}
      </div>
    </a>
  );
};

export default EssentialLinkButton;